import axios from "axios";
import pca from "../index";
import config from "../config/config";

// const fetchUrl = 'https://f13e-62-193-100-162.ngrok.io'

const api = axios.create({
  // baseURL: 'https://majorel.whitesmoke-5e5dd3ff.centralus.azurecontainerapps.io/',
  baseURL: config.baseURL,
  withCredentials: true, // essential to send a bearer token
  headers: {
    "Content-Type": "application/json",
  },
});

// Array to hold logs
export let logs = [];

// Function to add log to the logs array
const addLog = (message) => {
  logs.push(message);
};

// Add an interceptor to the Axios instance to include the access token in each request
api.interceptors.request.use(
  async (config) => {
    // Add the tenantId to the headers if it exists
    const tenant = JSON.parse(sessionStorage.getItem("userTenant"));

    if (tenant) {
      config.headers.tenantId = tenant.tenantId;
    }

    const accounts = await pca.getAllAccounts();
    //console.log(accounts);

    if (accounts.length > 0) {
      // Try to acquire a token silently
      const silentTokenResponse = await pca.acquireTokenSilent({
        account: pca.getActiveAccount(),
      });

      const token = silentTokenResponse.idToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        console.log("No token. Redirecting to login.");
        window !== window.parent ? pca.loginPopup() : pca.loginRedirect();
      }
    } else {
      console.log("No signed-in accounts. Redirecting to login.");
      window !== window.parent ? pca.loginPopup() : pca.loginRedirect();
    }

    config.headers["Content-Type"] = "application/json";

    const logMessage = `Starting Request to ${
      config.url
    }\nRequest Config: ${JSON.stringify(config, null, 2)}`;
    addLog(logMessage);

    return config;
  },
  (error) => {
    const errorMessage = `Error in Request: ${error}`;
    addLog(errorMessage);
    // Handle request error
    console.log(error);
  }
);

const handleUnauthorized = () => {
  console.error("Unauthorized: Redirecting to /unauthorized");
  //window.location = "/unauthorized";
};

api.interceptors.response.use(
  (response) => {
    // Handle the response, if needed
    if (response.status === 202) {
      if (response.data && response.data.statusCode == 403) {
        handleUnauthorized();
      } else if (response.data && response.data.statusCode == 404) {
        window.location = "/not-found";
      } else {
        const errorMessage = response.data
          ? "Network error: " + response.data.message
          : "Network error";
        // Dispatch an event with the error message
        window.dispatchEvent(
          new CustomEvent("api-error", { detail: errorMessage })
        );
      }
    }
    const logMessage = `Response from ${
      response.config.url
    }\nResponse Data: ${JSON.stringify(
      response.data,
      null,
      2
    )}\nResponse Status: ${response.status}`;
    addLog(logMessage);

    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      handleUnauthorized();
    }

    const errorMessage = error.response
      ? error.response.data.message
      : "Network error";
    // Dispatch an event with the error message
    window.dispatchEvent(
      new CustomEvent("api-error", { detail: errorMessage })
    );

    let logMessage = "";
    if (error.response) {
      logMessage = `Error Response from ${
        error.response.config.url
      }\nResponse Status: ${
        error.response.status
      }\nResponse Data: ${JSON.stringify(error.response.data, null, 2)}`;
    } else if (error.request) {
      logMessage = `No Response Received: ${error.request}`;
    } else {
      logMessage = `Error in Setup: ${error.message}`;
    }
    addLog(logMessage);

    return Promise.reject(error);
  }
);

export const errorApi = () =>
  api.post("https://jsonpla11ceholder.typicode.com/posts", {
    title: "foo",
    body: "bar",
    userId: 1,
  });

//  services api
export const insertService = (payload) => api.post(`/admin/service`, payload);
export const getAllServices = () => api.get(`/admin/service/all`);
export const getServiceById = (id) => api.get(`/admin/service?serviceId=${id}`);
export const updateServiceById = (payload) =>
  api.put(`/admin/service`, payload);
export const deleteServiceById = (id) =>
  api.delete(`/admin/service?serviceId=${id}`);

//  teams api
export const insertTeam = (payload) => api.post(`/admin/team`, payload);
export const getAllTeams = () => api.get(`/admin/team`);
export const getTeamById = (id) => api.get(`/admin/team/${id}`);
export const updateTeamById = (id, payload) =>
  api.patch(`/admin/team/${id}`, payload);
export const deleteTeamById = (id) => api.delete(`/admin/team/${id}`);

//  Admin lobs api
export const insertLob = (payload) => api.post(`/admin/lob`, payload);
export const getAllLobs = () => api.get(`/admin/lob`);
export const getLobById = (id) => api.get(`/admin/lob/${id}`);
export const updateLobById = (id, payload) =>
  api.patch(`/admin/lob/${id}`, payload);
export const deleteLobById = (id) => api.delete(`/admin/lob/${id}`);

//  forms and fields api
export const insertForm = (payload) => api.post(`/admin/form`, payload);
export const getAllForms = () => api.get(`/admin/form`);
export const getAllDisabledForms = () => api.get(`/admin/form?disabled=true`);
export const getAllEnabledForms = () => api.get(`/admin/form?disabled=false`);
export const getFormById = (id) => api.get(`/admin/form/${id}`);
export const updateFormById = (id, payload) =>
  api.patch(`/admin/form/${id}`, payload);
export const deleteFormById = (id) => api.delete(`/admin/form/${id}`);
export const getAllUnassignedForms = () => api.get(`/admin/form/unassigned`);

// vdn api
export const getInboundVdns = () => api.get(`/admin/vdn/inbound`);
export const addNewVdn = (payload) => api.post(`/admin/vdn/inbound`, payload);
export const deleteVdn = (id) => api.delete(`/admin/vdn/inbound/${id}`);
export const modifyInboundVdn = (id, payload) =>
  api.patch(`/admin/vdn/inbound/${id}`, payload);
export const getAllOutboundVdns = () => api.get(`admin/vdn/outbound`);
export const addNewOutboundVdn = (payload) =>
  api.post(`admin/vdn/outbound`, payload);
export const deleteOutboundVdn = (id) =>
  api.delete(`/admin/vdn/outbound/${id}`);
export const modifyOutboundVdn = (id, payload) =>
  api.patch(`/admin/vdn/outbound/${id}`, payload);

// phonebook api
export const getAllPhoneBookItems = () => api.get(`/admin/phonebook`);
export const postNewPhoneBookItem = (payload) =>
  api.post(`admin/phonebook`, payload);
export const deletePhoneBookItemById = (id) =>
  api.delete(`admin/phonebook/${id}`);
export const modifyPhoneBookItemById = (id, payload) =>
  api.patch(`admin/phonebook/${id}`, payload);

// users api
export const getAllUsers = () => api.get(`/admin/user/all`);
export const assignUserToTeam = (payload) =>
  api.post(`admin/user/assign`, payload);
export const unAssignUserToTeam = (payload) =>
  api.delete("/admin/user/assign", { data: payload });

export const getUserById = (id) => api.get(`/admin/user?userId=${id}`);

export const getUserConfig = () => api.get(`/user-config/custom/all`);
export const setUserConfig = (payload) =>
  api.put(`/user-config/custom/all`, payload);

// tenant idles
export const getAllTenantIdles = () => api.get(`admin/tenant-idle/all`);
export const getIdleNameById = (id) => api.get(`admin/idle/${id}`);
export const getAllIdleNames = () => api.get(`admin/idle`);
export const postNewTenantIdle = (payload) =>
  api.post(`admin/tenant-idle`, payload);
export const deleteTenantIdleById = (id) =>
  api.delete(`admin/tenant-idle/${id}`);
export const modifyTenantIdleById = (payload) =>
  api.patch(`/admin/tenant-idle/`, payload);

// master idles
export const getAllMasterIdles = () => api.get(`admin/master-idle/all`);
export const addNewMasterIdle = (payload) =>
  api.post(`admin/master-idle`, payload);
export const modifyMasterIdle = (payload) =>
  api.patch(`/admin/master-idle`, payload);
export const deleteMasterIdle = (id) => api.delete(`admin/master-idle/${id}`);

// admin tenant settings
export const getAppSettingsOfTenantByTenantId = (
  id = JSON.parse(sessionStorage.getItem("userTenant"))?.tenantId
) => api.get(`/admin/tenant-settings?tenantId=${id}`);
export const editAppSettingsForTenant = (payload) =>
  api.put(`/admin/tenant-settings/`, payload);

export const getUserTenants = () => api.get(`/admin/user/tenants`);
export const getAllTenants = () => api.get(`/admin/tenant/all`);
export const getAllActiveTenants = () => api.get(`/admin/tenant/all/active`);
export const editTenant = (payload) => api.put(`/admin/tenant`, payload);
export const addNewTenant = (payload) => api.post(`/admin/tenant`, payload);
export const getTenantById = (id) => api.get(`/admin/tenant?tenantId=${id}`);
//  SECTION & FIELDS APIs
export const createSection = (payload) => api.post(`/admin/section`, payload);
export const updateSection = (id, payload) =>
  api.patch(`/admin/section/${id}`, payload);
export const deleteSectionById = (id) => api.delete(`/admin/section/${id}`);
export const getSectionById = (id) => api.get(`/admin/section/${id}`);

export const createField = (payload) => api.post(`/admin/field`, payload);
export const getFieldById = (id) => api.get(`/admin/field/${id}`);
export const updateField = (id, payload) =>
  api.patch(`/admin/field/${id}`, payload);
export const deleteFieldById = (id) => api.delete(`/admin/field/${id}`);
export const isFieldNameDuplicatedWithinSection = (fieldName, sectionId) =>
  api.get(`/admin/field/duplicated?name=${fieldName}&sectionId=${sectionId}`);

// admin user roles
export const getUsersOfTenant = (id, page, size, searchName = "") =>
  api.get(
    `/admin/user/role/all?tenantId=${id}&page=${page}&size=${size}&searchText=${searchName}`
  );
export const getAllRoles = () => api.get(`/admin/role/all`);
export const assignRoleToUser = (payload) =>
  api.post(`/admin/user/role/assign`, payload);
export const createNewUser = (payload) => api.post(`/admin/user`, payload);
export const assignUserToTenant = (payload) =>
  api.post(`/admin/user/role/assign`, payload);
export const getUserRole = (
  username,
  tenantId = JSON.parse(sessionStorage.getItem("userTenant"))?.tenantId || 1
) => api.get(`/admin/user/role?tenantId=${tenantId}&username=${username}`);
export const unassignUserFromRole = (username, roleId, tenantId) =>
  api.delete(
    `admin/user/role/assign?roleId=${roleId}&username=${username}&tenantId=${tenantId}`
  );

// agent services
export const getAllAgentServices = () => api.get(`/agent/service/all`);
export const getAllAgentServicesFlat = () => api.get(`/agent/service/all/flat`);
export const getAllFilteredReports = (payload) =>
  api.post(`/agent/process/other`, payload);

//agent tenant idles
export const getAgentIdleCodes = () => api.get(`/agent/tenant-idle/all`);

//agent processes
export const insertProcess = (payload) => api.post(`/agent/process`, payload);
// export const insertInboundProcess = (payload) =>
//   api.post(`/agent/process/inbound-call-activity`, payload);
export const getAllProcesss = (startDate, endDate) =>
  api.get(`/agent/process?startDate=${startDate}&endDate=${endDate}`);

export const continueProcess = (id) =>
  api.patch(`/agent/process?processId=${id}`);

export const editProcessForm = (processId, formId) =>
  api.patch(`/agent/process/form?processId=${processId}&formId=${formId}`);

export const endProcess = (
  id,
  isEnded,
  payload,
  isSaveWhileNotActive = false
) =>
  api.put(
    `/agent/process?processId=${id}&isEnded=${isEnded}&isSaveData=true&isSaveWhileNotActive=${isSaveWhileNotActive}`,
    payload
  );

export const endProcessWithoutSaving = (id, isEnded, payload) =>
  api.put(
    `/agent/process?processId=${id}&isEnded=${isEnded}&isSaveData=false`,
    payload
  );

export const updateProcessDetails = (id, payload) =>
  api.post(
    `/agent/process/detail?processId=${id}&isDeletePrevious=true`,
    payload
  );

export const deleteProcessById = (id) =>
  api.delete(`/agent/process?processId=${id}`);

export const deleteProcessTime = (id) =>
  api.delete(`/agent/process/time?processTimeId=${id}`);

export const addProcessTime = (payload) =>
  api.post(`/agent/process/time`, payload);

export const saveTimeEdit = (payload) =>
  api.put(`/agent/process/time`, payload);

export const hasOverlap = (payload) => api.post(`/utils/overlap`, payload);

// agent offline activities search
export const getOfflineActivities = (payload) =>
  api.post(`/agent/process/offline-activities`, payload);

export const getOfflineActivitesMyOfflineActivities = (payload) =>
  api.post(`/agent/process/other`, payload);

// agent statistic endpoint
export const getAllStatistics = (startDate, endDate) =>
  api.get(
    `/agent/personalstatistics?startDate=${startDate}&endDate=${endDate}`
  );

// get all agent available contacts
export const getContactList = () => api.get(`/agent/phonebook`);

export const getAllAgentLobs = () => api.get(`/agent/lob`);

// get available outbound lines for agent
export const getAgentOutboundLines = () => api.get(`/agent/vdn/outbound`);

export const getAgentInboundVdns = () => api.get(`/agent/vdn/inbound`);

export const getAllAgentForms = () => api.get(`/agent/form`);

export const getAgentFormById = (id) => api.get(`/agent/form/${id}`);
export const getAgentTenantSettingsById = (id) =>
  api.get(`/agent/tenant-settings`);

export const getAgentUserRole = (username, tenantId = 1) =>
  api.get(`/agent/user/role?tenantId=${tenantId}&username=${username}`);

// database apis
export const getAllHouses = (pageSize, page, searchParam, searchValue) =>
  api.get(
    `/admin/house/all?size=${pageSize}&page=${page}&${searchParam}=${searchValue}`
  );

export const getAllHousesUnpaged = () => api.get(`/agent/house/all`);

export const getAllHousesUnpagedTenant = (tenantId) =>
  api.get(`/agent/house/all`, {
    headers: {
      Tenantid: tenantId, // or whatever header key your backend expects
    },
  });

export const addNewHouse = (name, houseId) =>
  api.post(`/admin/house?name=${name}&houseId=${houseId}`);

export const getHouseById = (id) => api.get(`/admin/house?houseId=${id}`);

export const getHouseByDid = (did) => api.get(`/admin/house?dId=${did}`);

export const getHouseByDidAgent = (did, tenantId) =>
  api.get(`/agent/house?dId=${did}`, {
    headers: {
      Tenantid: tenantId, // or whatever header key your backend expects
    },
  });

export const getHouseByIdAgent = (id) => api.get(`/agent/house?houseId=${id}`);

export const updateHouseDetailsById = (id, body) =>
  api.put(`/admin/house?houseId=${id}`, body);

export const deleteHouseById = (id) => api.delete(`/admin/house?houseId=${id}`);

const apis = {
  insertService,
  getAllServices,
  updateServiceById,
  deleteServiceById,
  getServiceById,
};
export default apis;
